import { useTranslation } from '@/context/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { Shield, Eye, FileCheck, Activity } from 'lucide-react';

export default function Security() {
  const { t } = useTranslation();

  const items = [
    { icon: Shield, title: t('security.dataProtection'), desc: t('security.dataProtectionDesc'), color: '#3A86FF' },
    { icon: Eye, title: t('security.privacy'), desc: t('security.privacyDesc'), color: '#3A86FF' },
    { icon: FileCheck, title: t('security.gdpr'), desc: t('security.gdprDesc'), color: '#00CC99' },
    { icon: Activity, title: t('security.audit'), desc: t('security.auditDesc'), color: '#F59E0B' },
  ];

  return (
    <div className="py-16 md:py-24" data-testid="security-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl text-[#1E293B] mb-4" >
            {t('security.title')}
          </h1>
          <p className="text-base md:text-lg text-[#64748B] max-w-2xl mx-auto">
            {t('security.subtitle')}
          </p>
        </div>
        <div className="grid sm:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          {items.map((item, i) => (
            <Card key={i} className="border border-[#E2E8F0]/40 shadow-[0_2px_8px_rgba(0,0,0,0.04)] rounded-2xl animate-fade-in-up" style={{ animationDelay: `${i * 0.1}s` }}>
              <CardContent className="p-8">
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-5" style={{ backgroundColor: `${item.color}15` }}>
                  <item.icon className="w-7 h-7" style={{ color: item.color }} strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-medium text-[#1E293B] mb-3" >{item.title}</h3>
                <p className="text-sm text-[#64748B] leading-relaxed">{item.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* GDPR Checklist */}
        <div className="mt-16 max-w-3xl mx-auto">
          <Card className="border border-[#E2E8F0]/40 rounded-2xl">
            <CardContent className="p-8">
              <h3 className="text-xl font-medium text-[#1E293B] mb-6" >
                {t('security.gdpr')} Checklist
              </h3>
              <div className="space-y-3">
                {[
                  'EU data residency',
                  'Privacy policy FR/EN',
                  'Consent banner & preferences',
                  'Data export flow',
                  'Account deletion flow',
                  '30-day log retention',
                  'Access controls & RLS',
                  'Signed URLs for private media',
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3 text-sm text-[#64748B]">
                    <div className="w-5 h-5 rounded-full border-2 border-[#00CC99] flex items-center justify-center flex-shrink-0">
                      <div className="w-2 h-2 rounded-full bg-[#00CC99]" />
                    </div>
                    {item}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
